import scrollMonitor from 'scrollmonitor';
import {
  hasClass,
  addClass,
  removeClass,
} from '../utilities/dom';
import { getBreakpoint } from '../utilities/breakpoints';

export default class {
  constructor({
    handle,
    header,
    links,
    link,
  }) {
    // Elements and class variables
    const { body } = document;
    const headerElement = document.querySelector(header);
    const linksContainer = document.querySelector(links);
    const linkSet = linksContainer.querySelectorAll(link);
    const sections = document.querySelectorAll('.main > section');

    Array.from(sections).forEach(section => {
      // Get section ID
      const sectionId = section.getAttribute('id');
      // Scroll watchers for sections
      const sectionWatcher = scrollMonitor.create(section, -200);
      // Function to listen for when section comes into view
      sectionWatcher.enterViewport(() => {
        Array.from(linkSet).forEach(link => {
          const linkTarget = link.getAttribute('href');
          const target = linkTarget.replace('#', '');
          if (target === sectionId) {
            if (!hasClass(link, 'is--active')) {
              addClass(link, 'is--active');
            }
          } else if (hasClass(link, 'is--active')) {
            removeClass(link, 'is--active');
          }
        });
      });
    });

    Array.from(linkSet).forEach(linkItem => {
      linkItem.addEventListener('click', () => {
        const headerTrigger = document.querySelector('.header__trigger-checkbox');
        headerTrigger.checked = false;
      });
    });
  }
}
